import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { send } from "../../app/appSlice";
import { AppThunkApi, RootState } from "../../app/store";
import { firstPage, Page } from "../../models/page";
import { FileDataPage, FileDataParams } from "../../services/fileData";

interface fileDataState {
  fileDataPage: Page;
}

const initialState: fileDataState = {
  fileDataPage: firstPage(),
};

// 分页
export const getFileListAsync = createAsyncThunk<
  Page,
  FileDataParams,
  AppThunkApi
>("fileDataList/page", async (params, api) => {
  return send(FileDataPage(params), api);
});

export const fileDataListSlice = createSlice({
  name: "fileDataListStation",
  initialState,
  reducers: {
    setFileDataList(state, action) {
      state.fileDataPage = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getFileListAsync.fulfilled, (state, action) => {
      state.fileDataPage = action.payload;
    });
  },
});

export const { setFileDataList } =
fileDataListSlice.actions;

export const selectFileDataList = (state: RootState): Page =>
  state.fileList.fileDataPage;

export default fileDataListSlice.reducer;
